// Precio del hospedaje noche por noche (espejo de src/lib/precioEstancia.js del servidor). Cada noche vale, en este orden:
// el precio fijado ese día en el calendario, el de la temporada que cubre la fecha o el precio base.
const nochesDe = (checkIn, checkOut) => {
  const fechas = [];
  if (!checkIn || !checkOut) return fechas;
  const fin = new Date(checkOut + 'T12:00:00Z');
  for (let d = new Date(checkIn + 'T12:00:00Z'); d < fin && fechas.length < 400; d.setUTCDate(d.getUTCDate() + 1)) {
    fechas.push(d.toISOString().split('T')[0]);
  }
  return fechas;
};

export const temporadaDe = (temporadas, fecha) => (temporadas || [])
  .filter(t => Number(t.precio) > 0 && t.desde <= fecha && fecha <= t.hasta)
  .sort((a, b) => b.id - a.id)[0] || null;

// Estadía mínima según la llegada (espejo de minimoDe del servidor): la temporada que cubre la llegada manda sobre la general
export const minimoDe = (minNights, temporadas, checkIn) => {
  const t = checkIn && (temporadas || [])
    .filter(t => Number(t.minNoches) > 0 && t.desde <= checkIn && checkIn <= t.hasta)
    .sort((a, b) => b.id - a.id)[0];
  return t ? Number(t.minNoches) : Math.max(1, parseInt(minNights) || 1);
};

export const precioEstancia = (basePrice, eventos, checkIn, checkOut, temporadas = []) => {
  const base = Number(basePrice) || 0;
  const porDia = {};
  for (const ev of eventos || []) {
    if (Number(ev.customPrice) > 0) porDia[ev.date] = Number(ev.customPrice);
  }
  const noches = nochesDe(checkIn, checkOut).map(fecha => ({ fecha, precio: porDia[fecha] ?? (Number(temporadaDe(temporadas, fecha)?.precio) || base) }));
  const hospedaje = noches.reduce((suma, n) => suma + n.precio, 0);
  return { noches, hospedaje, promedio: noches.length ? Math.round(hospedaje / noches.length) : base };
};
